import React from "react";
import './DetailsModal.scss'
import { useSelector } from 'react-redux';

const selector = state => {
    const { language, disableButtons, stations, companies, modalState } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        // selected: stations.selected,
        companies: companies.companies,
        modalState: modalState
    }
};

const DetailsModal = props => {
    const {closeMethod, children, title, addMethod, addTitle, editable} = props;
    const {t} = useSelector(selector)
    return (
        <div className='DetailsModal'>
            <div className="detailsModalWindow">
                <div className="detailsModalHeader">
                    <h1>{title}</h1>
                    {/*<div*/}
                    {/*    onClick={closeMethod}*/}
                    {/*    className='closeButtonHolder'>*/}
                    {/*    <CloseIcon  />*/}
                    {/*</div>*/}
                </div>
                <div className="detailsModalContent">
                    {children}
                </div>
                {/*<div className="detailsModalFooter">*/}
                {/*    {editable ?*/}
                {/*        <div*/}
                {/*            onClick={addMethod}*/}
                {/*            className="closeModalBtn">*/}
                {/*            {addTitle}*/}

                {/*        </div>*/}
                {/*        :*/}
                {/*        <div*/}
                {/*            onClick={closeMethod}*/}
                {/*            className="closeModalBtn">*/}
                {/*            {t.gettext('Close')}*/}
                {/*        </div>*/}
                {/*    }*/}
                {/*</div>*/}
            </div>
        </div>
    )
}

export default DetailsModal
